import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../hooks/useTheme.js';

/** Sun/Moon icon button that flips light/dark and persists the choice. */
export function ThemeToggle(): JSX.Element {
  const { theme, toggle } = useTheme();
  const { t } = useTranslation();
  const label = t('actions.toggleTheme', { defaultValue: 'Toggle theme' });
  return (
    <button type="button" className="icon-btn" onClick={toggle} aria-label={label} title={label}>
      {theme === 'dark' ? <Moon aria-hidden="true" /> : <Sun aria-hidden="true" />}
    </button>
  );
}
